import * as React from 'react';
import './GenericSaveAndBackButton.css';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

interface SaveAndBackButtonProps {
    backUrl?: string
    saveState?: SaveState
    saveButtonLabel?: string
    backLinkText?: string
    onSaveClicked: () => void,
    onBackClicked?: (evt: React.SyntheticEvent<HTMLAnchorElement>) => void
    statusMessage?: string
    statusMessageTone?: 'default' | 'error'
}

export enum SaveState {
    Standard = 'standard',
    Saving = 'saving',
    Saved = 'saved',
    SaveError = 'save-error',
    ValidationError = 'validation-error',
    NoChanges = 'no-changes',
    PendingChanges = 'pending-changes',
    LoadError = 'load-error',
}

const GenericSaveAndBackButtons = (props: SaveAndBackButtonProps) => (
    <div>
        <div className="save-and-back-button">
            <div className="column middle-valign">
                {renderBackButton(props)}
            </div>
            <div className="column right-align">
                {renderSaveButton(props)}
            </div>
        </div>
    </div>   
)

export default GenericSaveAndBackButtons;

function renderBackButton(props: SaveAndBackButtonProps) {
    const onClick = props.onBackClicked
        ? props.onBackClicked
        : () => {};
    const label = props.backLinkText || 'Back';

    const linkContent = (
        <>
            <LeftOutlined style={{ marginRight: 4 }} />
            {label}
        </>
    );

    if (!props.backUrl) {
        return <a href="#" onClick={onClick} className="back-link">
            {linkContent}
        </a>;
    }

    return <Link to={props.backUrl} onClick={onClick} className="back-link">
        {linkContent}
    </Link>;
}

function buttonLabelText(props: SaveAndBackButtonProps) {
    if (props.statusMessage)
        return props.statusMessage;
    if (props.saveButtonLabel)
        return props.saveButtonLabel;
    if (props.saveState === 'no-changes')
        return 'No changes detected';
    if (props.saveState === 'saved')
        return 'changes saved successfully';
    return '';
}

function renderButtonLabel(props: SaveAndBackButtonProps) {
    const labelText = buttonLabelText(props);
    if (!labelText)
        return undefined;

    const color = props.statusMessageTone === 'error' ? '#ff4d4f' : '#8c8c8c';

    return <span style={{ marginRight: 12, fontSize: 14, color }}>
        {labelText}
    </span>;
}

function renderSaveButton(props: SaveAndBackButtonProps) {
    const isPositive = 
        props.saveState === undefined || props.saveState === 'standard';
    const isLoading = props.saveState === SaveState.Saving
    const isDisabled = props.saveState !== SaveState.Standard && props.saveState !== SaveState.PendingChanges;

    return <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
        {renderButtonLabel(props)}
        <Button 
            type={isPositive ? "primary" : "default"}
            loading={isLoading} 
            disabled={isDisabled}
            size="large"
            onClick={props.onSaveClicked}>
            Save
        </Button>        
    </div>
}
